import React from 'react';
import PropTypes from 'prop-types';

import IconError from '../../Icons/IconError';
import IconWarning from '../../Icons/IconWarning';

function AlertMessage(props) {
  const { message, isWarning } = props;

  return (
    <div
      className={
                    isWarning
                      ? 'message-container message-container__warning'
                      : 'message-container message-container__error'
                }
    >
      {isWarning ? (
        <IconWarning fill="#FFB400" width="17.5" />
      ) : (
        <IconError fill="#FF4D93" width="17.5" />
      )}
      <span className="message-label">{message}</span>
    </div>
  );
}

AlertMessage.propTypes = {
  message: PropTypes.string.isRequired,
  isWarning: PropTypes.bool.isRequired,
};

export default AlertMessage;
